import {
  GET_REPORTING_CATEGORIES_REQUESTED,
  GET_REPORTING_CATEGORIES_SUCCEEDED,
  GET_REPORTING_CATEGORIES_FAILED,
  UPDATE_REPORTING_CATEGORY_REQUESTED,
  UPDATE_REPORTING_CATEGORY_SUCCEEDED,
  UPDATE_REPORTING_CATEGORY_FAILED,
  CREATE_REPORTING_CATEGORY_REQUESTED,
  CREATE_REPORTING_CATEGORY_SUCCEEDED,
  CREATE_REPORTING_CATEGORY_FAILED,
  GET_FILTERED_AND_PAGINATED_REPORTING_CATEGORIES_REQUESTED,
  GET_FILTERED_AND_PAGINATED_REPORTING_CATEGORIES_SUCCEEDED,
  GET_FILTERED_AND_PAGINATED_REPORTING_CATEGORIES_FAILED,
} from './constants'
import api from 'utils/api'

export const getReportingCategoriesRequested = () => ({
  type: GET_REPORTING_CATEGORIES_REQUESTED,
})

export const getReportingCategoriesSucceeded = (payload) => ({
  type: GET_REPORTING_CATEGORIES_SUCCEEDED,
  payload,
})

export const getReportingCategoriesFailed = () => ({
  type: GET_REPORTING_CATEGORIES_FAILED,
})

export const updateReportingCategoryRequested = () => ({
  type: UPDATE_REPORTING_CATEGORY_REQUESTED,
})

export const updateReportingCategorySucceeded = (payload) => ({
  type: UPDATE_REPORTING_CATEGORY_SUCCEEDED,
  payload,
})

export const updateReportingCategoryFailed = () => ({
  type: UPDATE_REPORTING_CATEGORY_FAILED,
})

export const createReportingCategoryRequested = () => ({
  type: CREATE_REPORTING_CATEGORY_REQUESTED,
})

export const createReportingCategorySucceeded = (payload) => ({
  type: CREATE_REPORTING_CATEGORY_SUCCEEDED,
  payload,
})

export const createReportingCategoryFailed = () => ({
  type: CREATE_REPORTING_CATEGORY_FAILED,
})

export const getFilteredAndPaginatedReportingCategoriesRequested =
  () => ({
    type: GET_FILTERED_AND_PAGINATED_REPORTING_CATEGORIES_REQUESTED,
  })

export const getFilteredAndPaginatedReportingCategoriesSucceeded = (
  payload
) => ({
  type: GET_FILTERED_AND_PAGINATED_REPORTING_CATEGORIES_SUCCEEDED,
  payload,
})

export const getFilteredAndPaginatedReportingCategoriesFailed =
  () => ({
    type: GET_FILTERED_AND_PAGINATED_REPORTING_CATEGORIES_FAILED,
  })

export const loadFilteredAndPaginatedReportingCategories =
  (data) => (dispatch) => {
    dispatch(getFilteredAndPaginatedReportingCategoriesRequested())

    return api
      .fetchFilteredAndPaginatedReportingCategories(data)
      .then((res) =>
        dispatch(
          getFilteredAndPaginatedReportingCategoriesSucceeded(res)
        )
      )
      .catch(() =>
        dispatch(getFilteredAndPaginatedReportingCategoriesFailed())
      )
  }

export const fetchReportingCategories = (venueUuid) => (dispatch) => {
  dispatch(getReportingCategoriesRequested())
  return api
    .fetchReportingCategories(venueUuid)
    .then((res) => {
      return dispatch(
        getReportingCategoriesSucceeded(res?.data?.itemCategories)
      )
    })
    .catch(() => {
      dispatch(getReportingCategoriesFailed())
    })
}

export const updateReportingCategories = (data) => (dispatch) => {
  dispatch(updateReportingCategoryRequested())
  return api
    .updateReportingCategory(data)
    .then((res) => {
      return dispatch(
        updateReportingCategorySucceeded(res?.data?.itemCategories)
      )
    })
    .catch(() => {
      dispatch(updateReportingCategoryFailed())
    })
}

export const createReportingCategory = (data) => (dispatch) => {
  dispatch(createReportingCategoryRequested())
  return api
    .createReportingCategory(data)
    .then((res) => {
      return dispatch(
        createReportingCategorySucceeded(res?.data?.itemCategories)
      )
    })
    .catch(() => {
      dispatch(createReportingCategoryFailed())
    })
}
